import React from 'react';
import {
  BrowserRouter, Navigate, Route, Routes,
} from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import AppShell from './components/AppShell';
import { SessionProvider, useSession } from './viewmodels/SessionViewModel';
import SignInView from './views/SignInView';
import SignUpView from './views/SignUpView';
import ForgotPasswordView from './views/ForgotPasswordView';
import NotEnabledView from './views/NotEnabledView';
import ChatView from './views/ChatView';
import TeamView from './views/TeamView';
import ApprovalsView from './views/ApprovalsView';
import ConnectionsView from './views/ConnectionsView';
import ActivityView from './views/ActivityView';
import TasksView from './views/TasksView';
import SchedulesView from './views/SchedulesView';
import TriggersView from './views/TriggersView';
import SettingsView from './views/SettingsView';

function FullPageSpinner() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <CircularProgress aria-label="Loading" />
    </Box>
  );
}

/** Signed-out visitors go to sign in; signed-in visitors of auth pages go to the chat. */
function PublicOnly({ children }) {
  const { status } = useSession();
  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'authed') return <Navigate to="/chat" replace />;
  return children;
}

function Protected({ children }) {
  const { status, allowed } = useSession();
  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'anon') return <Navigate to="/signin" replace />;
  if (!allowed) return <NotEnabledView />;
  return children;
}

export default function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<PublicOnly><SignInView /></PublicOnly>} />
          <Route path="/signup" element={<PublicOnly><SignUpView /></PublicOnly>} />
          <Route path="/forgot-password" element={<PublicOnly><ForgotPasswordView /></PublicOnly>} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/chat" element={<ChatView />} />
            <Route path="/chat/:id" element={<ChatView />} />
            <Route path="/team" element={<TeamView />} />
            <Route path="/tasks" element={<TasksView />} />
            <Route path="/schedules" element={<SchedulesView />} />
            <Route path="/triggers" element={<TriggersView />} />
            <Route path="/approvals" element={<ApprovalsView />} />
            <Route path="/connections" element={<ConnectionsView />} />
            <Route path="/activity" element={<ActivityView />} />
            <Route path="/settings" element={<SettingsView />} />
          </Route>
          <Route path="*" element={<Navigate to="/chat" replace />} />
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
}
